import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBoltComponent } from "./med-icon-bolt.component";

@NgModule({
  declarations: [
    MedIconBoltComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBoltComponent,
  ],
})
export class MedIconBoltModule { }
